import React from 'react';
import ReactDOM from 'react-dom';
import Home from './pages/Home';
import Error from './pages/Error';
import Success from './pages/success';
import { Switch, Route, HashRouter as Router } from 'react-router-dom';
import {
	PrivateRoute,
	PrivateStateFullRoute,
	initSentry,
	logger,
	Sentry,
	ErrorBoundary
} from 'common-utilities';
import * as serviceWorker from './serviceWorker';
import './index.scss';

// Initialize Sentry
initSentry();

// Global error handlers
window.addEventListener('unhandledrejection', event => {
	logger.error('Unhandled promise rejection:', event.reason);
	Sentry.captureException(event.reason);
});

window.onerror = (message, source, lineno, colno, error) => {
	logger.error('Global error:', { message, source, lineno, colno, error });
	Sentry.captureException(error || new Error(message));
};

ReactDOM.render(
	<React.StrictMode>
		<ErrorBoundary>
			<Router hashType={'slash'}>
				<Switch>
					<PrivateRoute paramsName={['code']} encodeTheUri={true} path="/success" exact>
						<PrivateStateFullRoute keyName="code">
							<Success />
						</PrivateStateFullRoute>
					</PrivateRoute>
					<Route path="/error" exact>
						<Error />
					</Route>
					<PrivateRoute path="/" paramsName={['code']} encodeTheUri={true}>
						<Home />
					</PrivateRoute>
				</Switch>
			</Router>
		</ErrorBoundary>
	</React.StrictMode>,
	document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
